import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { useAuth } from './AuthContext';
import type { Permission } from './permissions';

/** Route wrapper: renders the child routes only when the user holds the permission. */
export function RequirePermission({ permission }: { permission: Permission }) {
    const { can } = useAuth();
    const { t } = useTranslation();
    if (!can(permission)) {
        return <Alert severity="warning">{t('auth.noPermission')}</Alert>;
    }
    return <Outlet />;
}
